import { useMutation, useQueryClient } from '@tanstack/react-query';

import { translate } from '~l10n/client';
import { toast } from '~shared/components/Toast';
import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { renameWorkspace } from '../../../api/workspaces/rename/renameWorkspace';

export function useRenameWorkspace(closeCallback: () => void) {
  const queryClient = useQueryClient();
  const rename = useMutation({
    mutationFn: renameWorkspace,
    onSuccess: () => {
      closeCallback();
      toast.positive(translate('Successfully saved'));
      return queryClient.invalidateQueries(workspaceKeys.all);
    },
    onError: () => {
      toast.critical(translate('An error has occurred'));
    },
  });
  return { rename };
}
